export default __webpack_public_path__ + "static/media/Ekata-1.be215e36.jpg";